import { SxProps, Theme } from '@mui/material/styles';

import { paletteBase } from '@abg/kit-base';

export const locationTextFieldStyling: SxProps<Theme> = (theme: Theme) => ({
  '& .MuiFilledInput-input': {
    padding: '11px 14px',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('md')]: {
      padding: '0 !important',
      fontSize: '16px',
    },
  },

  [theme.breakpoints.up('md')]: {
    '& .MuiFilledInput-root.Mui-focused, & .MuiFilledInput-root:hover': {
      border: `1px solid ${paletteBase.black} !important`,
    },
  },

  '& .MuiFilledInput-root': {
    paddingRight: '0 !important',
    [theme.breakpoints.down('md')]: {
      height: '48px',
      paddingTop: '0 !important',
      paddingBottom: '0 !important',
      alignItems: 'center',
    },
  },
});

export const locationTextFieldLabelStyling: SxProps<Theme> = {
  marginBottom: '8px',
  fontSize: '14px',
};
